// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalClaimSearchResponseModel {
    static getAttributeTypeMap() {
        return MedicalClaimSearchResponseModel.attributeTypeMap;
    }
}
MedicalClaimSearchResponseModel.discriminator = undefined;
MedicalClaimSearchResponseModel.attributeTypeMap = [
    {
        "name": "claim",
        "baseName": "claim",
        "type": "ClaimMedicalClaimModel"
    },
    {
        "name": "claimDetails",
        "baseName": "claimDetails",
        "type": "ClaimDetailsResponseModel"
    }
];
//# sourceMappingURL=medicalClaimSearchResponseModel.js.map